import { QueryGroup } from "./@types";
import AutosuggestLoadMoreOption from "./components/AutosuggestLoadMoreOption";

export function addLoadMoreOptionsIfNecessary<T>(
  options: T[],
  pageSize: number,
  addMoreValue = "__more__"
): T[] {
  if (options.length > pageSize) {
    return [
      ...options.slice(0, pageSize),
      {
        label: <AutosuggestLoadMoreOption />,
        value: addMoreValue
      } as T
    ];
  }

  return options;
}

export const getLabelStringWithHighlightedPart = (
  suggestion: string,
  inputValue: string
) => {
  const getHighlightedPartIndex = suggestion
    .toLowerCase()
    .indexOf(inputValue.toLowerCase());
  const beforeHighlightedPart =
    getHighlightedPartIndex > -1
      ? suggestion.slice(0, getHighlightedPartIndex)
      : suggestion;
  const highlightedPart =
    getHighlightedPartIndex > -1
      ? suggestion.slice(
          getHighlightedPartIndex,
          getHighlightedPartIndex + inputValue.length
        )
      : "";
  const afterHighlightedPart =
    getHighlightedPartIndex > -1
      ? suggestion.slice(getHighlightedPartIndex + inputValue.length)
      : "";

  return {
    beforeHighlightedPart,
    highlightedPart,
    afterHighlightedPart
  };
};

export const stringValueIsProperlyQuoted = (value: string) => {
  const trimmedValue = value.trim();
  return (
    (trimmedValue.startsWith('"') &&
      trimmedValue.endsWith('"') &&
      trimmedValue.length > 1) ||
    (!trimmedValue.startsWith('"') && !trimmedValue.endsWith('"'))
  );
};

export const lintQuery = (query: readonly QueryGroup[]): QueryGroup[] => {
  const lintedQuery: QueryGroup[] = [];

  query.forEach(item => {
    if (lintedQuery.length === 0) {
      lintedQuery.push(item);
      return;
    }
    const previousItem = lintedQuery[lintedQuery.length - 1];
    if (item.value === "NOT" && previousItem.value === "NOT") {
      return;
    } else if (item.value === ")" && previousItem.value === "(") {
      lintedQuery.pop();
      return;
    }

    lintedQuery.push(item);
  });

  return lintedQuery;
};

export const valueIsKeywordOperator = (value: string) =>
  ["AND", "OR", "NOT", "(", ")"].includes(value.trim().toUpperCase());
